import { render, staticRenderFns } from "./DatasetSelect.vue?vue&type=template&id=91c72ecc&scoped=true"
import script from "./DatasetSelect.vue?vue&type=script&lang=js"
export * from "./DatasetSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91c72ecc",
  null
  
)

export default component.exports